var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "mt-5" },
    [
      _vm.error
        ? _c(
            "v-layout",
            { attrs: { row: "", wrap: "", "justify-space-around": "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "", lg5: "" } },
                [
                  _c("app-alert", {
                    attrs: { text: _vm.error.message },
                    on: { dismissed: _vm.onDismissed }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "", "justify-space-around": "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm6: "", lg5: "" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "prepend-icon": "mail",
                                  label: _vm.$t("email"),
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.email,
                                  callback: function($$v) {
                                    _vm.email =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "email"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          attrs: { "lazy-validation": "" },
                          model: {
                            value: _vm.isValid,
                            callback: function($$v) {
                              _vm.isValid = $$v
                            },
                            expression: "isValid"
                          }
                        },
                        [
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                row: "",
                                wrap: "",
                                "justify-space-between": ""
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md5: "" } },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "required_field",
                                    attrs: {
                                      "prepend-icon": "explore",
                                      label: _vm.$t("role"),
                                      items: _vm.roles,
                                      "item-text": "name",
                                      "item-value": "id",
                                      rules: [_vm.rules.checkNullStr("role")],
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.role,
                                      callback: function($$v) {
                                        _vm.role = $$v
                                      },
                                      expression: "role"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md6: "" } },
                                [
                                  _vm.role === "0" || _vm.role === "2"
                                    ? _c("v-text-field", {
                                        staticClass: "required_field",
                                        attrs: {
                                          "prepend-icon": "vpn_key",
                                          label: _vm.$t("referralNumber"),
                                          rules: [
                                            _vm.rules.checkNullStr(
                                              "referralNumber"
                                            )
                                          ]
                                        },
                                        model: {
                                          value: _vm.referralNum,
                                          callback: function($$v) {
                                            _vm.referralNum =
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                          },
                                          expression: "referralNum"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.role === "0"
                            ? _c(
                                "v-layout",
                                {
                                  attrs: {
                                    row: "",
                                    wrap: "",
                                    "justify-space-between": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { md5: "" } },
                                    [
                                      _c("v-autocomplete", {
                                        attrs: {
                                          "prepend-icon": "mode",
                                          clearable: "",
                                          name: "Org",
                                          label: _vm.$t("mode"),
                                          "item-text": "text",
                                          "item-value": "value",
                                          rules: [
                                            _vm.rules.checkNullStr("mode")
                                          ],
                                          items: _vm.modes
                                        },
                                        model: {
                                          value: _vm.mode,
                                          callback: function($$v) {
                                            _vm.mode = $$v
                                          },
                                          expression: "mode"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.mode !== "label"
                                    ? _c(
                                        "v-flex",
                                        _vm._b(
                                          {},
                                          "v-flex",
                                          { md6: _vm.role === "0" },
                                          false
                                        ),
                                        [
                                          _c("v-text-field", {
                                            ref: "warehouse",
                                            attrs: {
                                              "prepend-icon": "local_shipping",
                                              label: _vm.$t("warehouse")
                                            },
                                            model: {
                                              value: _vm.warehouseName,
                                              callback: function($$v) {
                                                _vm.warehouseName =
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                              },
                                              expression: "warehouseName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.mode === "label" && _vm.role === "0"
                            ? _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    [
                                      _c("v-text-field", {
                                        ref: "companyName",
                                        staticClass: "required_field",
                                        attrs: {
                                          "prepend-icon": "apartment",
                                          label: _vm.$t("companyName"),
                                          rules: [
                                            _vm.rules.checkNullStr(
                                              "companyName"
                                            )
                                          ]
                                        },
                                        model: {
                                          value: _vm.companyName,
                                          callback: function($$v) {
                                            _vm.companyName =
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                          },
                                          expression: "companyName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-text-field", {
                                    ref: "name",
                                    staticClass: "required_field",
                                    attrs: {
                                      "prepend-icon": "person",
                                      label: _vm.$t("username"),
                                      "error-messages": _vm.errorMsg,
                                      error: !_vm.isNameAvailable,
                                      rules: [
                                        _vm.rules.checkNullStr("username")
                                      ]
                                    },
                                    model: {
                                      value: _vm.name,
                                      callback: function($$v) {
                                        _vm.name =
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                      },
                                      expression: "name"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      "prepend-icon": "lock",
                                      label: _vm.$t("password"),
                                      type: "password",
                                      rules: [
                                        _vm.rules.checkNullStr("password"),
                                        _vm.rules.checkPasswordLength
                                      ]
                                    },
                                    model: {
                                      value: _vm.password,
                                      callback: function($$v) {
                                        _vm.password =
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                      },
                                      expression: "password"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "required_field",
                                    attrs: {
                                      "prepend-icon": "lock",
                                      label: _vm.$t("confirmPassword"),
                                      type: "password",
                                      rules: [
                                        _vm.rules.checkNullStr(
                                          "confirmPassword"
                                        ),
                                        _vm.rules.checkConfirmPwd,
                                        _vm.rules.checkPasswordLength
                                      ]
                                    },
                                    model: {
                                      value: _vm.confirmPwd,
                                      callback: function($$v) {
                                        _vm.confirmPwd =
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                      },
                                      expression: "confirmPwd"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                "align-baseline": "",
                                "justify-space-between": ""
                              }
                            },
                            [
                              _c("v-btn", { on: { click: _vm.clear } }, [
                                _vm._v("Clear")
                              ]),
                              _vm._v(" "),
                              _c("LoaderButton", {
                                attrs: {
                                  buttonText: _vm.$t("confirm"),
                                  promiseAwait: _vm.onFormSubmitted
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c68c1ee2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c68c1ee2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SignupContinue.vue
// module id = null
// module chunks = 